var _rect, _rect2, _g, _rect3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 38,
    viewBox: "0 0 44 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 0.09375,
    width: 37.8143,
    height: 37.8143,
    rx: 9.8646,
    fill: "white",
    fillOpacity: 0.05
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.41102,
    y: 0.504775,
    width: 36.9922,
    height: 36.9922,
    rx: 9.45357,
    stroke: "url(#paint0_linear_4389_61312)",
    strokeOpacity: 0.9,
    strokeWidth: 0.82205
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4389_61312)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.2406 10.666H13.574C11.8479 10.666 10.449 12.065 10.449 13.791V24.2077C10.449 25.9337 11.8479 27.3327 13.574 27.3327H30.2406C31.9667 27.3327 33.3656 25.9337 33.3656 24.2077V13.791C33.3656 12.065 31.9667 10.666 30.2406 10.666Z",
    fill: "url(#paint1_linear_4389_61312)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0739 17.9583C26.6492 17.9583 27.1156 17.492 27.1156 16.9167C27.1156 16.3414 26.6492 15.875 26.0739 15.875C25.4986 15.875 25.0322 16.3414 25.0322 16.9167C25.0322 17.492 25.4986 17.9583 26.0739 17.9583Z",
    fill: "#20302F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2406 17.9583C30.8159 17.9583 31.2823 17.492 31.2823 16.9167C31.2823 16.3414 30.8159 15.875 30.2406 15.875C29.6653 15.875 29.199 16.3414 29.199 16.9167C29.199 17.492 29.6653 17.9583 30.2406 17.9583Z",
    fill: "#20302F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9071 17.9583C22.4824 17.9583 22.9488 17.492 22.9488 16.9167C22.9488 16.3414 22.4824 15.875 21.9071 15.875C21.3318 15.875 20.8655 16.3414 20.8655 16.9167C20.8655 17.492 21.3318 17.9583 21.9071 17.9583Z",
    fill: "#20302F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7406 17.9583C18.3159 17.9583 18.7823 17.492 18.7823 16.9167C18.7823 16.3414 18.3159 15.875 17.7406 15.875C17.1653 15.875 16.699 16.3414 16.699 16.9167C16.699 17.492 17.1653 17.9583 17.7406 17.9583Z",
    fill: "#20302F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5739 17.9583C14.1492 17.9583 14.6156 17.492 14.6156 16.9167C14.6156 16.3414 14.1492 15.875 13.5739 15.875C12.9986 15.875 12.5322 16.3414 12.5322 16.9167C12.5322 17.492 12.9986 17.9583 13.5739 17.9583Z",
    fill: "#20302F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2406 22.1243C30.8159 22.1243 31.2823 21.658 31.2823 21.0827C31.2823 20.5074 30.8159 20.041 30.2406 20.041C29.6653 20.041 29.199 20.5074 29.199 21.0827C29.199 21.658 29.6653 22.1243 30.2406 22.1243Z",
    fill: "#20302F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5739 22.1243C14.1492 22.1243 14.6156 21.658 14.6156 21.0827C14.6156 20.5074 14.1492 20.041 13.5739 20.041C12.9986 20.041 12.5322 20.5074 12.5322 21.0827C12.5322 21.658 12.9986 22.1243 13.5739 22.1243Z",
    fill: "#20302F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.074 20.041C25.8802 20.041 17.9344 20.041 17.7406 20.041C17.1656 20.041 16.699 20.5077 16.699 21.0827C16.699 21.6577 17.1656 22.1243 17.7406 22.1243C17.9344 22.1243 25.8802 22.1243 26.074 22.1243C26.649 22.1243 27.1156 21.6577 27.1156 21.0827C27.1156 20.5077 26.649 20.041 26.074 20.041Z",
    fill: "#20302F"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6.57678,
    y: 3.67053,
    width: 30.6624,
    height: 30.6624,
    rx: 6.28868,
    stroke: "url(#paint2_linear_4389_61312)",
    strokeOpacity: 0.4,
    strokeWidth: 0.575435
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4389_61312",
    x: -0.457369,
    y: -3.3646,
    width: 44.7292,
    height: 44.7292,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.9323
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.533333 0 0 0 0 0.890196 0 0 0 0 0.866667 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4389_61312"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4389_61312",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4389_61312",
    x1: 52.5187,
    y1: 59.9664,
    x2: 18.8378,
    y2: 0.0937519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6EDDAF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8EBFF",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4389_61312",
    x1: 17.8969,
    y1: 10.666,
    x2: 28.411,
    y2: 38.2841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3CACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D6366"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4389_61312",
    x1: 20.3461,
    y1: 34.6207,
    x2: 20.7366,
    y2: 3.38281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6EDDAF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8EBFF",
    stopOpacity: 0.6
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGear);
export default __webpack_public_path__ + "static/media/gear.2a7f15eadcca951b8af45440604dbe9b.svg";
export { ForwardRef as ReactComponent };